import { render, staticRenderFns } from "./AerationGrid.vue?vue&type=template&id=15b358af&scoped=true"
import script from "./AerationGrid.vue?vue&type=script&lang=ts"
export * from "./AerationGrid.vue?vue&type=script&lang=ts"
import style0 from "./AerationGrid.vue?vue&type=style&index=0&id=15b358af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b358af",
  null
  
)

export default component.exports